import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CharacterAvatarsQueryVariables = Types.Exact<{
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
  filters?: Types.InputMaybe<Types.CharacterAvatarsFilters>;
}>;


export type CharacterAvatarsQuery = { characterAvatars: { totalCount: number, success: boolean, edges?: Array<{ node: { id: string, avatar_name: string, avatar_id: string, gender?: Types.VideoCharacterGenderEnum | null, default_voice_id?: string | null, preview_image_url?: string | null, preview_talking_url?: string | null, preview_video_url?: string | null, provider: Types.VideoCharacterProviderEnum } }> | null, pageInfo?: { hasNextPage?: boolean | null, endCursor?: string | null } | null } };


export const CharacterAvatarsDocument = /*#__PURE__*/ gql`
    query CharacterAvatars($sort: [SortType!], $after: String, $first: Float, $filters: CharacterAvatarsFilters) {
  characterAvatars(sort: $sort, after: $after, first: $first, filters: $filters) {
    totalCount
    edges {
      node {
        id
        avatar_name
        avatar_id
        gender
        default_voice_id
        preview_image_url
        preview_talking_url
        preview_video_url
        provider
      }
    }
    totalCount
    success
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

export function useCharacterAvatarsQuery(options?: Omit<Urql.UseQueryArgs<CharacterAvatarsQueryVariables>, 'query'>) {
  return Urql.useQuery<CharacterAvatarsQuery, CharacterAvatarsQueryVariables>({ query: CharacterAvatarsDocument, ...options });
};